import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Bankdetails(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.UPDATEBANKDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPDATEBANKDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.UPDATEBANKDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}